import { BrandDeadlinesSnapshot } from "./AboveProperty";
import { TemplatePlansSnapshot } from "./AboveProperty";

export const getKeyMetricsHotelViewData = (snapshot: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Properties",
      data: snapshot?.totalPropertiesCount
    },
    { subTitle: "Active", data: snapshot?.activePropertiesCount, showBorder: true },
    {
      subTitle: "Overdue Properties",
      data: snapshot?.overduePlanPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Adding Plans",
      data: snapshot?.addingPlanPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Completing Plans",
      data: snapshot?.completedPlanPropertiesCount
    }
  ];
};

export const getKeyMetricsPlanViewData = (snapshot: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Library Plans",
      data: snapshot?.libraryPlansCount
    },
    { subTitle: "Total Property Plans", data: snapshot?.propertyPlansCount, showBorder: true },
    {
      subTitle: "Plans via Assignment",
      data: snapshot?.plansViaAssignmentsCount,
      showBorder: true
    },
    {
      subTitle: "Overdue",
      data: snapshot?.overduePropertyPlansCount,
      showBorder: true
    },
    {
      subTitle: "*Completed",
      data: snapshot?.completedPlansCount
    }
  ];
};

export const getKeyMetricsTemplatePlanViewData = (snapshot?: TemplatePlansSnapshot) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Template Plans",
      data: snapshot?.templatePlansCount
    },
    { subTitle: "Total Plans Assigned", data: snapshot?.totalAssignedPlansCount, showBorder: true },
    { subTitle: "Active", data: snapshot?.activePlansCount, showBorder: true },
    { subTitle: "Overdue", data: snapshot?.overduePlansCount, showBorder: true },
    {
      subTitle: "*Completed",
      data: snapshot?.completedPlansCount
    }
  ];
};

export const getKeyMetricsBrandDeadlinesData = (snapshot?: BrandDeadlinesSnapshot) => {
  return [
    {
      isPrimary: true,
      subTitle: "Available Brand Deadlines",
      data: snapshot?.plansCount
    },
    { subTitle: "Total Plans Added", data: snapshot?.totalAssignedPlansCount, showBorder: true },
    { subTitle: "Active", data: snapshot?.activePlansCount, showBorder: true },
    { subTitle: "Overdue", data: snapshot?.overduePlansCount, showBorder: true },
    {
      subTitle: "*Completed",
      data: snapshot?.completedPlansCount
    }
  ];
};
